<template>
  <div class="page">
    <div class="itemrow">
      <div class="title">1.请输入姓名（填空）</div>
      <div>
        <el-input v-model="name" placeholder="请输入内容"></el-input>
      </div>
    </div>

    <div class="itemrow">
      <div class="title">2.曾经或正在华山皮肤科学习？（单选）</div>
      <div>
        <van-radio-group v-model="islearning">
          <van-radio name="1" checked-color="#1D2A5A" icon-size="20px">A.是的</van-radio>
          <van-radio name="2" checked-color="#1D2A5A" icon-size="20px">B.没有</van-radio>
        </van-radio-group>
      </div>
    </div>

    <div class="itemrow">
      <div class="title">3.是否添加了华肤荟助理微信（单选）</div>
      <div>
        <van-radio-group v-model="islearning">
          <van-radio name="1" checked-color="#1D2A5A" icon-size="20px">A.已添加</van-radio>
          <van-radio name="2" checked-color="#1D2A5A" icon-size="20px">B.未添加</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="upbtn">提交</div>
  </div>
</template>

<script>
export default {
  name: 'getidentity',
  data() {
    return {
      name: "",
      islearning: ""
    }
  },
  created() {
    document.title = "华肤荟";
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: .5rem 5%;
  box-sizing: border-box;
}

.itemrow {
  background: #f9f9f9;
  box-sizing: border-box;
  padding: 0.4rem 0.2rem;
  border-radius: 4px;
  margin-bottom: .5rem;
}

.title {
  margin-bottom: 0.5rem;
  padding-bottom: 0.3rem;
  border-bottom: 1px solid #e5e5e5;
}

.van-radio {
  margin-bottom: .3rem;
}

.upbtn {
  text-align: center;
  width: 80%;
  background: #1D2A5A;
  color: #fff;
  padding: 0.2rem 0;
  margin: auto;
  border-radius: 1.333333rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5%;
  z-index: 100;
}
</style>